import { IApplicationContext } from '../../../types/applicationContext';
import {
  fetchReceiptDetailsSave,
  type IReceiptDetailsSaveRequest,
  type TReceiptDetailsSaveResponse,
} from '../../../repositories/dailyrent/v1/receipt-details/save';

export async function fetchSaveFormData(context: IApplicationContext, parameters: IReceiptDetailsSaveRequest) {
  const { httpApi, logger } = context;

  try {
    const response: TReceiptDetailsSaveResponse = await fetchReceiptDetailsSave({
      httpApi,
      parameters,
    });

    if (response.statusCode !== 200 || response.response.errors) {
      throw new Error(`Failed to save form data. Error: ${response.response.errors}`);
    }

    return response as TReceiptDetailsSaveResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
